import {
  ADDRESS_LINE_1,
  ADDRESS_LINE_2,
  FACEBOOK_URL,
  HOURS_TEXT,
  INSTAGRAM_URL,
  LOGO_URL,
  PHONE_DISPLAY,
  PHONE_TEL,
  SHOP_URL,
} from "@/pages/home/constants";
import { withUtm } from "@/utils/shopUrl";

const socialLinks = [
  { icon: "ri-instagram-line", label: "Instagram de Iokus", href: INSTAGRAM_URL },
  { icon: "ri-facebook-circle-line", label: "Facebook de Iokus", href: FACEBOOK_URL },
  { icon: "ri-store-2-line", label: "Tienda online de Iokus", href: SHOP_URL },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-950 pb-28 text-background-100 md:pb-12">
      <div className="mx-auto w-full max-w-content px-4 pt-14 md:px-6 md:pt-16">
        <div className="grid gap-10 md:grid-cols-3 md:gap-8">
          <div>
            <div className="inline-flex rounded-xl bg-background-50 p-3">
              <img
                src={LOGO_URL}
                alt="Logo de Iokus, juegos y juguetes de madera hechos en Colombia"
                title="Iokus Guatapé"
                className="h-7 w-auto md:h-8"
              />
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-200">
              Iokus · Uniendo generaciones.
            </p>
            <p className="mt-2 text-sm leading-relaxed text-background-200/80">
              Juegos de mesa y juguetes de madera hechos a mano en Colombia.
            </p>
          </div>

          <div>
            <h2 className="text-base font-heading font-semibold text-background-50">Visítanos</h2>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-2-line mt-0.5 text-base text-primary-300" aria-hidden="true"></i>
                <span>
                  {ADDRESS_LINE_1}
                  <br />
                  {ADDRESS_LINE_2}
                </span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line mt-0.5 text-base text-primary-300" aria-hidden="true"></i>
                <span>{HOURS_TEXT}</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line mt-0.5 text-base text-primary-300" aria-hidden="true"></i>
                <a
                  href={PHONE_TEL}
                  className="cursor-pointer underline-offset-4 transition-colors hover:text-background-50 hover:underline"
                >
                  {PHONE_DISPLAY}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-base font-heading font-semibold text-background-50">Síguenos</h2>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              {socialLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={withUtm(link.href)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex min-h-[44px] items-center gap-3 cursor-pointer transition-colors hover:text-background-50"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10">
                      <i className={`${link.icon} text-lg`} aria-hidden="true"></i>
                    </span>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-background-50/15 pt-6 text-center text-xs text-background-200/70">
          Iokus · Uniendo generaciones
        </div>
      </div>
    </footer>
  );
}